import http from "@/api/http.js";

export function getReceptions(filters) {
  const params = new URLSearchParams();
  if (filters.departamentoId) params.append("departamento_id", filters.departamentoId);
  if (filters.warehouseId) params.append("warehouse_id", filters.warehouseId);
  if (filters.status) params.append("status", filters.status);
  if (filters.documentNumber) params.append("document_number", filters.documentNumber);
  if (filters.page) params.append("page", filters.page);
  if (filters.limitPerPage) params.append("limitPerPage", filters.limitPerPage);
  return http.get(`/receptions?${params.toString()}`).then(res => res.data);
}

export function getReception(id) {
  return http.get(`/receptions/single/${id}`).then(res => res.data);
}

export function deleteReception(id) {
  return http.delete(`/receptions/single/${id}`).then(res => res.data);
}

export function completeReception(id) {
  return http.put(`/receptions/complete/${id}`).then(res => res.data);
}

export function searchInfoautoDocuments(params) {
  const query = new URLSearchParams();
  if (params.tipo) query.append("tipo", params.tipo);
  if (params.fechaIni) query.append("fecha_ini", params.fechaIni);
  if (params.fechaFin) query.append("fecha_fin", params.fechaFin);
  if (params.numeroDoc) query.append("numero_doc", params.numeroDoc);
  if (params.departmentCode) query.append("department_code", params.departmentCode);
  if (params.clienteId) query.append("cliente_id", params.clienteId);
  return http.get(`/receptions/search_infoauto?${query.toString()}`).then(res => res.data);
}

export function createFromInfoauto(data) {
  return http.post("/receptions/from_infoauto", {
    documento_id: data.documentoId,
    departamento_id: data.departamentoId,
    department_code: data.departmentCode,
    warehouse_id: data.warehouseId,
    warehouse_code: data.warehouseCode,
    tipo: data.tipo || "",
    notes: data.notes || ""
  }).then(res => res.data);
}

export function verifyReception(id, note) {
  return http.put(`/receptions/verify/${id}`, { note: note || "" }).then(res => res.data);
}

export function confirmReception(id, note) {
  return http.put(`/receptions/confirm/${id}`, { note: note || "" }).then(res => res.data);
}
